import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { VideoCardPlayButton } from "../../Video/VideoCardPlayButton";
import { useStream } from "../PopularVideoSection/StreamContext";
import { Typography } from "@parkschannel/ui";
export const TvContent = (param)=>{
    let { children , onClick  } = param;
    const stream = useStream();
    if (!stream) return null;
    return /*#__PURE__*/ _jsxs("article", {
        className: "max-w-3xl",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "mb-6 ml-1",
                children: /*#__PURE__*/ _jsx(VideoCardPlayButton, {
                    onClick: onClick,
                    initialVisible: true
                })
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "h1",
                className: "line-clamp-3 text-white pb-[3px] mb-2 lg:mb-3",
                children: stream.currentlyPlayingMediaSummary.item.title
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "bodyXL",
                className: "line-clamp-3 text-white",
                children: stream.currentlyPlayingMediaSummary.item.description
            }),
            children
        ]
    });
};
